var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnhide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5C6.58291 5 2.30028 8.08832 0 12.6668C2.30028 17.246 6.58291 20.3335 11.5 20.3335C16.4171 20.3335 20.6997 17.246 23 12.6668C20.6997 8.08832 16.4171 5 11.5 5ZM11.5 17.4585C8.85326 17.4585 6.70824 15.3135 6.70824 12.6668C6.70824 10.02 8.85326 7.875 11.5 7.875C14.1467 7.875 16.2918 10.02 16.2918 12.6668C16.2918 15.3135 14.1467 17.4585 11.5 17.4585Z",
    fill: "#EB6E1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.542C13.0878 15.542 14.375 14.2548 14.375 12.667C14.375 11.0792 13.0878 9.79199 11.5 9.79199C9.91218 9.79199 8.625 11.0792 8.625 12.667C8.625 14.2548 9.91218 15.542 11.5 15.542Z",
    fill: "#EB6E1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhide);
export default __webpack_public_path__ + "static/media/unhide.3ba05aa77f68a3b6b630166b111e9b01.svg";
export { ForwardRef as ReactComponent };